<template>
  <div>
    <spacer :y="4"/>
    <loader-simple :flag="flag.loader">
      <ul v-if="!flag.loader">
        <stack-item>
          <contents-box
            title="相談履歴"
            :bg="userBoxColor(targetUser)">

            <div :class="$style.historyCount">
              <p :class="$style.historyCountTotal">実施総数　{{ historyCount.reserve.done + historyCount.text.done }} 回</p>
              <p v-if="onlineVirtualCountLabel">
                <span>{{ onlineVirtualCountLabel }}　</span>
                <span>実施 {{ historyCount.reserve.done }} 回</span>
                <span> / </span>
                <span>当日キャンセル {{ historyCount.reserve.cancelOnTheDay }} 回</span>
                <span> / </span>
                <span>事前キャンセル {{ historyCount.reserve.cancelBefore }} 回</span>
              </p>
              <p v-if="historyCount.text.done > 0">
                <span>テキスト　</span>
                <span>{{ historyCount.text.done }} 回</span>
              </p>
            </div>

            <user-box
              v-if="targetUser"
              :user="targetUser"
              :ownUser="user"
              :showId="true"
              :showCocomoniBtn="true"
            />

            <spacer
              v-if="!flag.isHistory"
              :y="4" />
            <contents-box
              v-if="!flag.isHistory"
              title="予約">
              <p :class="$style.date">{{ formatTimestamp(reserve.schedule.date, `YYYY年MM月DD日（${reserve.weekday.label}） HH:00 - HH:45`) }}</p>
              <spacer :y="2"/>
              <user-box :showId="false" :user="reserve.fromUser">
                <template v-slot:main>
                  <spacer :y="2"/>
                  <ul :class="$style.detail">
                    <li>
                      <label-box label="お悩み" color="gray" size="sm" :class="$style.label"/>
                      <p :class="$style.content">
                        <span
                          v-for="rtype in sortWorryTypes(reserve.type)"
                          :key="rtype"
                          :class="[$style.types, hasSubTypesRecorded(reserve) ? $style.typesCompany : '']">{{ getWorryTypeLabel(rtype, isCompany, 'reserve') }}<span v-if="reserve.other_text && rtype === 6">（{{ reserve.other_text }}）</span>
                          <span v-if="getWorrySelectedSubText(rtype, getRecordedSubs(reserve, rtype), isCorporate, 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(rtype, getRecordedSubs(reserve, rtype), isCorporate, 'reserve') }}</span>
                        </span>
                      </p>
                    </li>
                    <li>
                      <label-box label="ココモニ" color="gray" size="sm" :class="$style.label"/>
                      <ul :class="$style.who5">
                        <li v-for="(item, i) in helper.master.who5.items" :key="item">
                          <p>{{ item.label }}</p>
                          <p>{{ helper.master.who5.labels[reserve.who5Answer.answers[i]] }}</p>
                        </li>
                      </ul>
                    </li>
                    <li class="n2br">
                      <label-box :label="isCompany ? '企業コメント' : '学校コメント'" color="gray" size="sm" :class="$style.label"/>
                      <p
                        v-if="reserve.memos.teacher.length"
                        v-html="reserve.memos.teacher[0].memo"></p>
                      <p v-if="!reserve.memos.teacher.length">記入なし</p>
                    </li>
                  </ul>
                  <spacer :y="4"/>
                  <div
                  :class="$style.textareaDiv"
                  :flag="flag.memo">
                    <textarea
                      name="memo"
                      id="memo"
                      :rows="kartePlaceholder.rows"
                      :value="memo"
                      v-on:input="updateMemo"
                      :class="$style.textarea">
                    </textarea>
                    <!-- 注釈は 1 行で書く（改行・インデントが multilineText の pre-wrap で描画されるため）。
                         カルテ欄は li.n2br の傘の外なので、改行保持は multilineText を自前で付ける。 -->
                    <div
                    id="placeholderDiv"
                    v-if="!flag.memo"
                    :class="$style.placeholderDiv"
                    class="multilineText">{{ kartePlaceholder.note }}</div>
                  </div>
                  <p :class="$style.assistant">※保存せずにページを離れると入力した内容は失われます。忘れずに保存してください。</p>
                  <spacer :y="2"/>
                  <btn-container>
                    <basic-btn tag="button" v-on:click="registMemo">保存</basic-btn>
                  </btn-container>
                </template>
              </user-box>
            </contents-box>


            <spacer :y="4"/>
            <histories
              :histories="histories"
              :showNew="false"
              :hideCounseling="true"
              :targetUser="targetUser"/>
          </contents-box>
        </stack-item>
      </ul>
    </loader-simple>
    <spacer :y="4"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BasicBtn from '@/views/components/BasicBtn.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import LabelBox from '@/views/components/LabelBox.vue';
import Histories from '@/views/components/Histories.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import UserBox from '@/views/components/UserBox.vue';
import StackItem from '@/views/components/StackItem.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import Spacer from '@/views/components/Spacer.vue';
import cf from '@/mixins/commonFunctions.js';
import corporateSchool from '@/mixins/corporateSchool.js';
import { KARTE_NOTE_SCHOOL, KARTE_NOTE_CORPORATE } from '@/constants/counselorKarte.js';

export default {
  name: 'history',
  mixins: [cf, corporateSchool],
  components: {
    BasicBtn,
    BtnContainer,
    LabelBox,
    Histories,
    ContentsBox,
    UserBox,
    StackItem,
    LoaderSimple,
    Spacer,
  },
  data() {
    return {
      flag: {
        loader: true,
        memo: true,
        isHistory: false,
      },
      slug: null,
      userId: null,
      targetUser: null,
      reserve: null,
      reserves: [],
      texts: [],
      histories: [],
      memo: null,
    };
  },
  created() {
    const slug = cf.convert2Num(this.$route.params.slug);
    this.slug = slug;
    this.getReserve();

    if (this.$route.query && this.$route.query.isHistory) {
      this.flag.isHistory = true;
    }
  },
  computed: {
    ...mapState(['user', 'helper']),
    isCompany() {
      return Boolean(this.reserve && this.reserve.fromUser && this.reserve.fromUser.school.length && this.reserve.fromUser.school[0].is_company);
    },
    // 企業固有のお悩みサブ項目ゲート専用（インターン id=18 では false）。ラベル(#3238)は isCompany 据え置き。
    isCorporate() {
      return this.isCorporateSchool(this.reserve?.fromUser?.school);
    },
    // カルテ注釈は報告書記入画面（Counselor/Report.vue）と共通で、文言の出所は
    // constants/counselorKarte.js。注釈はオーバーレイ描画で textarea の高さと連動しない
    // （textarea は UA 既定の line-height: normal で 1 行が注釈の 1 行より低い）ため、
    // 行を増減したら rows も対で実測し直すこと。あふれた分は overflow: hidden で見切れる。
    // 版の選択は isCompany（非学校＝インターン・企業）軸。注釈の構成は全組織で共通にし、
    // 本人確認の例に出す身分証だけを替えるため、インターンは企業版を見る。
    // 企業版 16 行は rows=22 が必要な実測に 1 行の余裕を足して 23。
    // 学校版 17 行は rows=23 が必要（Chromium。Firefox は 22）で、同じく 1 行足して 24。
    kartePlaceholder() {
      return this.isCompany
        ? { note: KARTE_NOTE_CORPORATE, rows: 23 }
        : { note: KARTE_NOTE_SCHOOL, rows: 24 };
    },
    reserveHistories() {
      return this.histories.filter((h) => h.type === 'reserve' || h.type === 'virtualReserve'); // オンライン/バーチャル相談履歴のみ
    },
    textHistories() {
      return this.histories.filter((h) => h.type === 'text' && h.content.flag === 11); // テキスト相談履歴のみ（実施済み）
    },
    historyCount() {
      return {
        reserve: {
          done: this.reserveHistories.filter((h) => [11].includes(h.content.flag)).length, // 実施済み
          cancelOnTheDay: this.reserveHistories.filter((h) => [902].includes(h.content.flag)).length, // 当日キャンセル
          cancelBefore: this.reserveHistories.filter((h) => [901, 903].includes(h.content.flag)).length, // 事前キャンセル
        },
        text: {
          done: this.textHistories.length,
        },
      };
    },
    onlineVirtualCountLabel() {
      const hasOnline = this.reserveHistories.some((h) => h.content._counselingType.counseling_type === 1);
      const hasVirtual = this.reserveHistories.some((h) => h.content._counselingType.counseling_type === 3);
      if (hasOnline && hasVirtual) return 'オンライン・バーチャル';
      if (hasOnline) return 'オンライン';
      if (hasVirtual) return 'バーチャル';
      return '';
    },
  },
  methods: {
    // 対象の予約取得
    getReserve() {
      const params = {
        id: this.slug,
        counseling_type: this.$route.query.type === 'virtual' ? 3 : 1,
      };
      this.axios({
        method: 'get',
        url: '/v1/reserve/get/detail',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.userId = res.reserve.from_user_id;
          this.reserve = res.reserve;
          if (this.reserve.memos.counselor[0]) this.memo = this.reserve.memos.counselor[0].memo;
          if (!this.memo) {
            this.flag.memo = false;
          } else if (this.memo) {
            this.flag.memo = true;
          }
          this.getUser();
          this.getHistory();
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },

    // 利用者取得
    getUser() {
      const params = {
        id: this.userId,
        isRisk: 1,
        includeDeleted: 1,
        isUserWatch: 1, // UserWatchの有無
      };
      this.axios({
        method: 'GET',
        url: '/v1/user/get/detail',
        params,
      })
        .then((response) => {
          this.targetUser = response.data.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
    // 複合履歴取得
    getHistory() {
      const params = { userId: this.userId };

      this.axios({
        method: 'GET',
        url: '/v1/history/get/list',
        params,
      })
        .then((response) => {
          const res = response.data.data.data;
          this.histories = res.filter((elem) => elem.content.flag !== 1);
          this.reserves = res.filter((elem) => (elem.type === 'reserve' && elem.content.flag === 1)); // 予約の欄に追加するのは未実施のオンラインのみ
          // TODO ここに手入れが必要か要判断
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          this.flag.loader = false;
        });
    },

    sortHistories() {
      this.histories = [];
      const now = this.formatTimestamp(new Date(), 'YYYY-MM-DD HH:mm:ss');
      this.reserves.history.forEach((row) => {
        const schedule = this.formatTimestamp(row.schedule.date, 'YYYY-MM-DD HH:mm:ss');
        if (schedule < now) {
          this.histories.push({
            date: schedule,
            type: 'reserve',
            content: row,
          });
        }
      });
      this.texts.answered.forEach((row) => {
        this.histories.push({
          date: row.created_at,
          type: 'text',
          content: row,
        });
      });
      this.texts.progress.forEach((row) => {
        this.histories.push({
          date: row.created_at,
          type: 'text',
          content: row,
        });
      });
      this.histories.sort((a, b) => {
        if (a.date > b.date) return -1;
        return 1;
      });
      this.flag.loader = false;
    },
    updateMemo(e) {
      this.memo = e.target.value;
      if (this.memo) {
        this.flag.memo = true;
      } else if (!this.memo) {
        this.flag.memo = false;
      }
    },
    registMemo() {
      const data = {
        reserve_id: this.reserve.id,
        memo: this.memo,
        user_id: this.user.id,
      };

      if (this.reserve.memos.counselor[0]) data.id = this.reserve.memos.counselor[0].id;
      else data.id = null;

      const endpoint = data.id ? 'updater' : 'register';

      this.axios({
        method: 'POST',
        url: `/v1/reserve/memo/set/${endpoint}`,
        data,
      })
        .then(() => {
          alert('カルテを保存しました。');
          this.getReserve();
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" module>
.date {
  font-weight: bold;
}
.detail {
  li {
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    @include sm-view {
      display: block;
    }
    .content {
      font-size: 14px;
      margin-top: 3px;
      flex: 1;
    }
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    > p {
      flex: 1;
    }
  }
}
.label {
  width: 100px;
  margin-right: 20px;
}
.who5 {
  flex: 1;
  li {
    justify-content: space-between;
  }
}
.types {
  margin-right: 8px;
  &:not(:first-child) {
    &:before {
      content: "/";
    }
  }
  // 「その他」自由記述などで長い半角英字連続が来た時の折り返し（#3244）
  > span {
    word-break: break-all;
    overflow-wrap: break-word;
    // 自由記述は本文 bold とは別の通常重みで表示する
    font-weight: normal;
  }
}
.textareaDiv {
  position: relative;

  .textarea {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: none;
    appearance: none;
    padding: 20px;
    outline: none;
    z-index:0;
    position: relative;
    resize: vertical;
    min-height: 170px;
    background-color: var(--gray-sub);
  }
  .placeholderDiv{
    border: none;
    // 背景がグレー塗り（--gray-sub）のため、従来のグレーではコントラスト比が約 2.5:1 で読みづらい。
    // 4.5:1 を満たす濃さへ変更する（値は ReserveFormWizard.vue の ::placeholder と揃える）。
    color: #6d6d6d;
    position: absolute;
    top: 0px;
    left: 0px;
    padding: 20px;
    font-size: 14px;
    z-index: 1;
    pointer-events:none;
    // 注釈が textarea より縦に長くても枠外へはみ出さない安全弁（あふれた分は見切れる）。
    // 収まる高さは textarea 側の rows で調整する。
    width: 100%;
    max-height: 100%;
    overflow: hidden;
  }
}
.assistant {
  font-size: 12px;
  color: var(--pink);
}
.historyCount {
  font-size: 16px;
  margin-bottom: 12px;
  margin-left: 1rem;
  font-weight: bold;
  .historyCountTotal {
    font-size: 18px;
    margin-bottom: 5px;
  }
}
// sub_type が保存されているレコードはメインを縦並びにしてセパレータを消す
.typesCompany {
  display: block;
  &:not(:first-child)::before {
    content: '';
  }
}
// 企業サイト: メイン項目の下に「選択済み」サブ項目を ' / ' 連結で表示する。
// 表示形は予約入力の確認ステップ（ReserveFormWizard の確認欄）に合わせてある。
// span を block 化して親 <span> 内で改行させる。テンプレ側は1行で書くこと
// （親に white-space: pre-wrap が効く画面があり、改行・インデントが空白として可視化されるため）。
.subList {
  display: block;
  margin: 2px 0 8px 20px;
  font-size: 13px;
  color: #555;
}
</style>
